import { styled } from 'styled-system/jsx'

const RingWrap = styled('div', {
  base: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

const RingSvg = styled('svg', {
  base: {
    transform: 'rotate(-90deg)',
  },
})

const TrackCircle = styled('circle', {
  base: {
    fill: 'none',
    stroke: '#F0EDFA',
  },
})

const ProgressCircle = styled('circle', {
  base: {
    fill: 'none',
    stroke: 'quickpass.primary',
    strokeLinecap: 'round',
    transition:
      'stroke-dashoffset {durations.standard} {easings.appleStandard}',
  },
})

const Center = styled('div', {
  base: {
    position: 'absolute',
    inset: '0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'display',
    color: 'quickpass.ink',
  },
})

const PercentText = styled('span', {
  base: {
    fontSize: '20px',
    fontWeight: '800',
    letterSpacing: '-0.4px',
    color: 'quickpass.primary',
  },
})

const RingLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '10px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'quickpass.inkSoft',
    marginTop: '2px',
  },
})

export {
  RingWrap,
  RingSvg,
  TrackCircle,
  ProgressCircle,
  Center,
  PercentText,
  RingLabel,
}
